import React from 'react';

import { useCollection } from './providers/CollectionProvider';
import SheetFilter from './SheetFilter';
import SheetSearchPanel from './SheetSearchPanel';

const SheetFiltersPanel = (props) => {
  const { isFeatureEnabled: enableCollectionFeature } = useCollection();

  return enableCollectionFeature ? (
    <SheetSearchPanel {...props} />
  ) : (
    <SheetFilter {...props} />
  );
};

export default SheetFiltersPanel;
